/**
 * Remove the `page=N` query parameter from a URL param string.
 * Used when switching from page-based to infinite-scroll queries,
 * since the infinite query manages `page` internally via `pageParam`.
 *
 * Safe against similarly-named params like `per_page`, `current_page`, etc.
 */
export function stripPageParam(paramStr: string): string {
  return paramStr.replace(/([?&])page=\d+(&?)/, (_, prefix, suffix) => (suffix ? prefix : prefix === '?' ? '?' : ''));
}
